module.exports = __webpack_public_path__ + "static/media/slap.bac301ee.wav";